import { FC } from 'react'
import { Text, TextProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type MenuProps = TextProps & UnistylesVariants<typeof stylesheet>

const Menu: FC<MenuProps> = ({ children, size = 'normal', style, ...props }) => {
    const { styles } = useStyles(stylesheet, { size })

    return (
        <Text {...props} style={[styles.menu, style]}>
            {children}
        </Text>
    )
}

const stylesheet = createStyleSheet((theme) => ({
    menu: {
        fontFamily: theme.fonts.bold,
        variants: {
            size: {
                large: {
                    fontSize: 16,
                },
                normal: {
                    fontSize: 14,
                },
                small: {
                    fontSize: 12,
                },
            },
        },
    },
}))

export default Menu
